import { Tour } from "nextstepjs";
import { getDeviceType } from "@/helpers/storeLocatorHelper";
const deviceType = getDeviceType();

const searchGuide: Tour[] = [
  {
    tour: "searchTour",
    steps: [
      {
        icon: "",
        title: "",
        content: "Switch between tabs to quickly find what you're looking for.",
        selector: "#Search_products",
        side: deviceType === "mobile" ? "top" : "bottom",
        showControls: true,
        showSkip: true,
        pointerPadding: 2,
        pointerRadius: 10,
      },
    ],
  },
];

export default searchGuide;
